export default __webpack_public_path__ + "static/media/cancel-circle.69c9c552.svg";